import React, { useContext, useState } from 'react';
import renderHtml from 'htmr';
import Loadable from 'react-loadable';
import { decode } from 'html-entities';

import VideoSection from '../../components/Read/VideoSection';
import { FEATURED_SCROLLID, FOOTER_VIDEO_SCROLLID, VIDEO_SCROLLID } from '../../utils/constants';
import BgImage from '../../images/svg-gcbooks/bg-image';
import AdditionalVideoCard from '../BookChapters/AdditionalVideoCard';
import PodCastTopSliderItem from '../podcast/PodCastTopSliderItem';
import IsMobilecheck from '../../utils/ismobile';
import { extractYoutubeId, formatReadDuration, getVideoUrl } from '../../utils/functions';
import { AuthorSection } from '../BookChapters/Author-section';
import ChapterActions from './ChapterActions';
import { AppContext } from '../../apollo/wrap-root-element';
import { getGcUi } from '../../constants/spanish-gc';
import { normalizeGcQuoteText, renderGcChapterHtmlBlocks } from '../../utils/gcChapterText';
import GcReadPhotosPair from '../BookGreatControversy/GcReadPhotosPair';
import ChapterSummaryByline from '../BookGreatControversy/ChapterSummaryByline';
import GcReadPhotosTriple from '../BookGreatControversy/GcReadPhotosTriple';
import {
  getPhotoImgAlt,
  shouldUseGcPhotoGridCoverFitLayout,
  shouldUseGcPhotoGridFullLayout,
  shouldUseGcPhotoGridLayout,
  shouldUseGcPhotoTripleLayout,
  shouldUseInsetPhotoLayout,
  sliceUsesInsetPhotoLayout,
} from '../../utils/bookChapterPhoto';
import '../BookGreatControversy/gc-read-photo.scss';
import '../BookGreatControversy/gc-read-text.scss';

const loader = () => <div>Loading...</div>;

const LoadableCarousel = Loadable({
  loader: () => import('../Carousel/CarouselSlider'),
  loading: loader,
});

export default function ReadPageContent(props) {
  const {
    body,
    tableReadItem,
    featuredVideo,
    readDuration,
    postBanner,
    chapterTitle,
    from,
    footerVideoThumbnailImage,
    featuredVideoThumbnailImage,
    footerVideo,
    discussionQuestions,
    featuredVideoDuration,
    audioDetails,
    additionalVideos,
    category,
    featuredPodcast,
    showReadModal,
    setShowReadModal,
    showShareMenu,
    setShowShareMenu,
    featuredPodcastVideoUrl,
    title,
    locale = 'en',
    chapterUid,
    useFullReadPage = false,
    fullReadPath,
    showReadAction = false,
  } = props;
  const ui = getGcUi(locale);
  const questionsGC = discussionQuestions;
  const { selectedPodCast, setSelectedPodcast, isAudioPause, SetIsAudioPause, readvideoPlaying } =
    useContext(AppContext);
  const [isHovered, setisHovered] = useState(false);
  const isMobile = IsMobilecheck();
  const featuredPodcastTitle = featuredPodcast?.data?.podCastTitle?.[0]?.text || title?.text || '';
  const featuredPodcastUrl = featuredPodcast?.uid ? `/podcast/${featuredPodcast.uid}` : '';
  const podcastVideoId = featuredPodcastVideoUrl ? extractYoutubeId(featuredPodcastVideoUrl) : '';
  const podcastVideoEmbedUrl = podcastVideoId ? `${getVideoUrl(podcastVideoId)}&rel=0` : '';
  const shouldRenderPodcastSection = Boolean(featuredPodcast);

  //i am getting uid here fetch the podcast by uid

  const getClassFromSection = (type, hasBg, isFirst) => {
    if (isFirst) return 'm_top';
    if (type === 'video') return 'pd-0';
    if (type === 'quote') return 'pd-x-sm';
    if (hasBg) return 'p_bottom pd-x-sm';
    return 'pd-x-sm';
  };

  const getBodyClassName = (afterBackground = false, hasBackground) => {
    if (afterBackground) return 'overBg bg-transparent';
    if (hasBackground) return 'hasBG bgImage';
    return 'bg-transparent';
  };

  const getBodyBackgroundImageUrl = (body) => {
    if (body && body.sections && body.sections.length > 0) {
      const firstS = body.sections[0];
      if (firstS && firstS.sectionBackgroundImage && firstS.sectionBackgroundImage.sourceUrl)
        return firstS.sectionBackgroundImage.sourceUrl;
    }
    return '';
  };

  const getColorClassFromName = (name, hasBG = false) => {
    if (name === 'Black') return 'bg-transparent';
    if (name === 'Grey') return 'bg-gray';

    return 'bg-light';
  };

  const getContentTypeString = (type, color, length) => {
    if (type === 'video') return 'r_s_video';
    if (type === 'quote') return `${color === 'Black' ? 'r_s_quotes' : ''} r_s_contents`;
    if (type === 'image') {
      if (length === 1) return 'r_s_image';
      if (length === 2) return 'r_s_figures';
      return 'r_s_carousel';
    }
    return 'r_s_contents';
  };

  const fetchContentByType = (content, type) => {
    if (type === 'photo') {
      return content?.items;
    }

    if (['video', 'text', 'quote'].includes(type)) {
      return content?.primary;
    }

    return content;
  };

  const renderGcTextWidth = (children) => (
    <div className="gc-text-section-padding">
      <div className="wrapper" style={{ display: 'flex', margin: 'auto' }}>
        <div className="r_s_inner">{children}</div>
      </div>
    </div>
  );

  const renderSectionContent = (section, overBg, isFirst) => {
    if (section.type === 'text') {
      const { sectionContents } = section?.content;

      return (
        <div className="wrapper wrapper-md pd-x-sm" id={from === 'gc' ? 'pd-x-xmgc' : `${section?.id}`}>
          <div className="wrapper-sm" style={{ display: from === 'gc' ? 'flex' : 'block', margin: 'auto' }}>
            <div className={`r_s_c_inner${from === 'gc' ? ' gc-read-text' : ''}`}>
              {from === 'gc'
                ? renderGcChapterHtmlBlocks(decode(sectionContents.html))
                : renderHtml(decode(sectionContents.text))}
            </div>
          </div>
        </div>
      );
    }

    if (section.type === 'video') {
      const sliceVideoImageUrl = section?.content?.sliceVideoThumbnail?.fluid?.src;
      return isFirst ? (
        <div className="wrapper wrapper-lg">
          <VideoSection
            postBanner={featuredVideoThumbnailImage}
            from={from}
            section={section}
            scrollId={from === 'gc' ? FEATURED_SCROLLID : ''}
            chapterTitle={chapterTitle}
          />
        </div>
      ) : (
        <VideoSection
          postBanner={from === 'gc' ? sliceVideoImageUrl : postBanner}
          from={from}
          section={section}
          scrollId={from === 'gc' ? VIDEO_SCROLLID : ''}
          chapterTitle={chapterTitle}
        />
      );
    }

    if (section.type === 'quote') {
      const { sectionContents } = section?.content;

      return (
        <div className="wrapper wrapper-md pd-x-sm overflow-hidden" id={from === 'gc' ? 'pd-x-xmgc' : ''}>
          <div className="r_s_quote-inner">
            <div className="r_s_quote-content">
              <p>{renderHtml(decode(normalizeGcQuoteText(sectionContents.text)))}</p>
            </div>
          </div>
        </div>
      );
    }

    if (section.type === 'photo') {
      if (section?.content && section?.content?.length > 0) {
        switch (section.content.length) {
          case 1: {
            const photo = section.content[0];
            const imageSrc = photo?.image?.fluid?.src;
            const imageAlt = photo?.image?.alt;
            const caption = photo?.caption?.text || '';

            if (!photo?.image || !imageSrc) return null;

            if (from === 'gc' && shouldUseGcPhotoGridCoverFitLayout(imageAlt)) {
              const aspectRatio = photo?.image?.fluid?.aspectRatio;

              return renderGcTextWidth(
                <div className="gc-read-photo gc-read-photo--grid-cover-fit">
                  <figure className="gc-read-photo__figure">
                    <div
                      className={`gc-read-photo__media${aspectRatio ? ' gc-read-photo__media--has-ratio' : ''}`}
                      style={aspectRatio ? { aspectRatio } : undefined}
                    >
                      <img src={imageSrc} alt={getPhotoImgAlt(imageAlt, caption)} loading="lazy" />
                    </div>
                    {caption && <figcaption className="gc-read-photo__caption">{caption}</figcaption>}
                  </figure>
                </div>
              );
            }

            if (from === 'gc' && shouldUseGcPhotoGridFullLayout(imageAlt)) {
              return renderGcTextWidth(
                <div className="gc-read-photo gc-read-photo--grid-full">
                  <figure className="gc-read-photo__figure">
                    <img src={imageSrc} alt={getPhotoImgAlt(imageAlt, caption)} loading="lazy" />
                    {caption && <figcaption className="gc-read-photo__caption">{caption}</figcaption>}
                  </figure>
                </div>
              );
            }

            if (from === 'gc' && shouldUseInsetPhotoLayout(imageAlt)) {
              return (
                <div className="gc-read-photo">
                  <figure className="gc-read-photo__figure">
                    <img src={imageSrc} alt={getPhotoImgAlt(imageAlt, caption)} loading="lazy" />
                    {caption && <figcaption className="gc-read-photo__caption">{caption}</figcaption>}
                  </figure>
                </div>
              );
            }

            return (
              <div className="wrapper wrapper-lg">
                <div className="media ratio_16-9">
                  <div className="m_overlay-image bgImage" style={{ backgroundImage: `url(${imageSrc})` }} />
                </div>

                {caption && (
                  <p
                    style={{
                      width: '100%',
                      textAlign: 'right',
                      fontWeight: 'normal',
                      fontSize: '12px',
                    }}
                  >
                    {caption}
                  </p>
                )}
              </div>
            );
          }
          case 2:
            if (from === 'gc' && shouldUseGcPhotoGridLayout(section.content)) {
              return renderGcTextWidth(<GcReadPhotosPair photos={section.content} />);
            }

            if (from === 'gc' && sliceUsesInsetPhotoLayout(section.content)) {
              return renderGcTextWidth(
                <div className="gc-read-photos-row">
                  {section.content.map(
                    (img, idx) =>
                      img?.image?.fluid?.src && (
                        <figure className="gc-read-photos-row__item" key={img.image.fluid.src || idx}>
                          <div className="gc-read-photos-row__media">
                            <img
                              src={img.image.fluid.src}
                              alt={getPhotoImgAlt(img?.image?.alt, img?.caption?.text || '')}
                              loading="lazy"
                            />
                          </div>
                          {img?.caption?.text && (
                            <figcaption className="gc-read-photos-row__caption">{img.caption.text}</figcaption>
                          )}
                        </figure>
                      )
                  )}
                </div>
              );
            }

            if (from === 'gc') {
              return renderGcTextWidth(
                <div className="r_s_figures">
                  <div className="r_s_figures-list d-flex col-two">
                    {section?.content?.map(
                      (img) =>
                        img &&
                        img.image &&
                        img.image.fluid && (
                          <div className="r_s_figure-item" key={img.image.fluid.src}>
                            <div className="media ratio_4-3">
                              <div
                                className="m_overlay-image bgImage"
                                style={{
                                  backgroundImage: `url(${img.image.fluid.src})`,
                                }}
                              />
                            </div>
                            {img?.caption?.text && (
                              <p className="gc-read-photo__caption gc-read-photo__caption--banner">
                                {img.caption.text}
                              </p>
                            )}
                          </div>
                        )
                    )}
                  </div>
                </div>
              );
            }

            return (
              <div className="wrapper wrapper-lg">
                <div className="r_s_figures-list d-flex col-two">
                  {section?.content?.map(
                    (img) =>
                      img &&
                      img.image &&
                      img.image.fluid && (
                        <div className="r_s_figure-item">
                          <div className="media ratio_4-3">
                            <div
                              className="m_overlay-image bgImage"
                              style={{
                                backgroundImage: `url(${img.image.fluid.src})`,
                              }}
                            />
                          </div>
                        </div>
                      )
                  )}
                </div>
              </div>
            );

          case 3:
            if (from === 'gc' && shouldUseGcPhotoTripleLayout(section.content)) {
              return renderGcTextWidth(<GcReadPhotosTriple photos={section.content} />);
            }

            if (from === 'gc') {
              return renderGcTextWidth(
                <div className="r_s_figures r_s_figures--three">
                  <div className="r_s_figures-list d-flex col-three">
                    {section.content.map(
                      (img, idx) =>
                        img?.image?.fluid?.src && (
                          <div className="r_s_figure-item" key={img.image.fluid.src || idx}>
                            <div className="media ratio_1-1">
                              <div
                                className="m_overlay-image bgImage"
                                style={{ backgroundImage: `url(${img.image.fluid.src})` }}
                              />
                            </div>
                            {img?.caption?.text && (
                              <p className="gc-read-photo__caption">{img.caption.text}</p>
                            )}
                          </div>
                        )
                    )}
                  </div>
                </div>
              );
            }

            return (
              <div className="wrapper wrapper-lg">
                <div className="r_s_figures r_s_figures--three">
                  <div className="r_s_figures-list d-flex col-three">
                    {section.content.map(
                      (img, idx) =>
                        img?.image?.fluid?.src && (
                          <div className="r_s_figure-item" key={img.image.fluid.src || idx}>
                            <div className="media ratio_1-1">
                              <div
                                className="m_overlay-image bgImage"
                                style={{ backgroundImage: `url(${img.image.fluid.src})` }}
                              />
                            </div>
                            {img?.caption?.text && (
                              <p style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '6px' }}>
                                {img.caption.text}
                              </p>
                            )}
                          </div>
                        )
                    )}
                  </div>
                </div>
              </div>
            );

          default:
            return (
              <div className="wrapper wrapper-lg">
                <LoadableCarousel
                  className="r_s_carousel-list owl-carousel"
                  responsiveClass
                  margin={20}
                  responsive={{
                    0: {
                      items: 1,
                      nav: false,
                      stagePadding: 40,
                    },
                    576: {
                      items: 2,
                      nav: false,
                      stagePadding: 40,
                    },
                    768: {
                      items: 3,
                      nav: false,
                      loop: false,
                    },
                    1200: {
                      items: 3,
                      nav: true,
                      loop: false,
                    },
                  }}
                >
                  {section?.content?.map(
                    (img) =>
                      img &&
                      img.image &&
                      img.image.fluid && (
                        <div className="r_s_carousel-item">
                          <div className="media ratio_9-16">
                            <div
                              className="m_overlay-image bgImage"
                              style={{
                                backgroundImage: `url(${img.image.fluid.src})`,
                              }}
                            />
                          </div>
                        </div>
                      )
                  )}
                </LoadableCarousel>
              </div>
            );
        }
      }
    }

    return null;
  };

  if (!!body?.length) {
    return (
      <div className={`read-body ${from !== 'gc' && 'read-page'}`} id="divcontents">
        <div className={`wrapper wrapper-xl  ${from !== 'gc' && 'pd-x-md'}`}>
          <div id="video" className={`wrapper wrapper-xl ${from !== 'gc' && 'pd-x-md wrapper_read_page_video'} `}>
            {from === 'gc' && featuredVideo?.text && (
              <div className={`wrapper wrapper-xl  ${from === 'gc' ? '' : 'pd-x-md'}`}>
                <VideoSection
                  from={from}
                  featuredVideoDuration={featuredVideoDuration}
                  section={featuredVideo}
                  isFeaturedVideo={true}
                  postBanner={featuredVideoThumbnailImage}
                  banner={postBanner}
                  scrollId={FEATURED_SCROLLID}
                  chapterTitle={chapterTitle}
                />
              </div>
            )}

            {from !== 'gc' && featuredVideo?.text && (
              <div
                //hoverset
                onMouseEnter={() => setisHovered(true)}
                onMouseLeave={() => setisHovered(false)}
                className="read_page_video_section"
              >
                <VideoSection
                  banner={postBanner}
                  section={featuredVideo}
                  isFeaturedVideo={true}
                  postBanner={featuredVideoThumbnailImage}
                />
              </div>
            )}
          </div>

          {from === 'gc' && featuredVideo?.text && (
            <ChapterSummaryByline
              locale={locale}
              beforeBody
              contentLayout="read"
              readMoreHref={showReadAction && useFullReadPage && fullReadPath ? fullReadPath : undefined}
            />
          )}

          <div style={{ position: 'relative' }}>
            <div
              style={{
                position: isMobile ? 'static' : 'absolute',
                top: isMobile ? '10px' : '30px',
                right: isMobile ? '10px' : '30px',
                paddingTop: isMobile ? '20px' : '0',
                zIndex: 99999,
              }}
              className="flex-row-end"
            >
              <div
                style={{
                  paddingLeft: isMobile ? '30px' : '0',
                  alignItems: isMobile ? 'start' : 'flex-end',
                }}
                className="wrapper wrapper-xl  pd-x-md  read-flex"
              >
                {readDuration?.raw?.length > 0 && readDuration?.raw[0]?.text && (
                  <div className="m_run-time">
                    <span>{formatReadDuration(readDuration?.raw[0]?.text)}</span>
                  </div>
                )}
              </div>
            </div>

            {body.map((content, index) => {
              const { sliceType: contentType } = content;
              //fetched id
              const contentid = content.id;

              const typeSpecificContent = fetchContentByType(content, contentType);

              const section = {
                content: typeSpecificContent,
                type: contentType,
                id: contentid,
              };

              const backgroundColor =
                contentType === 'text' ? typeSpecificContent?.backgroundColor : content?.primary?.backgroundColor;
              const isImage = contentType === 'photo';
              const imageLength = isImage ? typeSpecificContent?.content?.length : null;

              const contentTypeClassName = getContentTypeString(contentType, backgroundColor, imageLength);
              const classFromSection = getClassFromSection(contentType, isImage, index === 0);

              const colorClassName = getColorClassFromName(backgroundColor);

              return (
                <div
                  key={contentid || index}
                  id="article"
                  className={`wrapper wrapper-xl  ${from === 'gc' ? 'study-article' : 'pd-x-md'}`}
                >
                  <div className={`section ${contentTypeClassName} ${classFromSection} ${colorClassName}`}>
                    {renderSectionContent(section, true, index === 0)}
                  </div>
                </div>
              );
            })}
          </div>

          {shouldRenderPodcastSection && (
            <div id="podcast" className="featured_podcast wrapper wrapper-xl pd-x-md">
              {podcastVideoEmbedUrl ? (
                <div className="featured-podcast-video">
                  <div className="featured-podcast-video__player">
                    <iframe
                      title={featuredPodcastTitle}
                      src={podcastVideoEmbedUrl}
                      style={{ width: '100%', height: '100%' }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                  <div className="featured-podcast-video__meta">
                    <div>
                      <p className="label">Video Podcast</p>
                      <h3>{featuredPodcastTitle}</h3>
                    </div>
                    <div className="featured-podcast-video__cta-group">
                      {featuredPodcastUrl && (
                        <a className="btn btn-link" href={featuredPodcastUrl}>
                          View Podcast Details
                        </a>
                      )}
                      <button
                        type="button"
                        className="btn btn-outline"
                        onClick={() => {
                          setSelectedPodcast(featuredPodcast);
                          SetIsAudioPause(false);
                        }}
                      >
                        Listen To Audio
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => {
                    setSelectedPodcast(featuredPodcast);
                    SetIsAudioPause(!isAudioPause);
                  }}
                >
                  <PodCastTopSliderItem
                    podCast={featuredPodcast}
                    showWaterMark={true}
                    isPlay={selectedPodCast?.uid === featuredPodcast?.uid && !isAudioPause}
                  />
                </div>
              )}
            </div>
          )}

          {additionalVideos && additionalVideos.length > 0 ? (
            <div>
              <div className="cat_watch-list bg-gray">
                {additionalVideos.length > 0 && (
                  <>
                    <div className="d-flex columns-3">
                      {additionalVideos.map((ep) => (
                        <AdditionalVideoCard
                          style={{
                            marginBottom: '0px !important',
                          }}
                          className="cols  add-columns-3"
                          key={ep.id}
                          data={ep}
                          type="landscape"
                          showPlayIcon
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : null}
          <ChapterActions
            audioDetails={audioDetails}
            showShareMenu={showShareMenu}
            setShowShareMenu={setShowShareMenu}
            setShowReadModal={setShowReadModal}
            locale={locale}
            chapterUid={chapterUid}
            useFullReadPage={useFullReadPage}
            fullReadPath={fullReadPath}
          />
          {from === 'gc' ? (
            <>
              <div
                style={{
                  paddingTop: '30px',
                }}
                className="wrapper wrapper-xl pd-x-md bg-gray gc-questions-container"
                id="pd-x-xmgc"
              >
                <h4 className="gcQuestionsHeader">{ui.discussionQuestions}</h4>
                {questionsGC?.map((item) => {
                  return <h5 className="gcquestions">{item?.discussionQuestion?.text}</h5>;
                })}
                <div className="gcquestionsIcon">
                  <BgImage />
                </div>
              </div>
              <div
                style={{
                  paddingTop: '40px',
                  paddingBottom: '10px',
                  paddingLeft: '20px',
                  backgroundColor: 'white',
                  paddingRight: '20px',
                }}
                className={`wrapper wrapper-xl`}
              >
                <AuthorSection locale={locale} />
              </div>
            </>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }

  return null;
}
